import React from "react"
import { Card, CardBody } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"

const IPListComponent = ({
  data,
  error,
  loading,
  onClickDelete,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onExportBtnClick,
  exportStatus,
}) => {
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading} // Boolean flag to display loading state
            title={"List"} // String to display as the header title
            rowCount={true} // Boolean to show/hide the row number selector
            onChangeRowNumber={onChangeRowNumber} // Callback function to handle row number selection change
            orderingList={true} // Boolean to show/hide ordering dropdown
            onChangeOrdering={onChangeOrdering} // Callback function triggered when the ordering option is changed
            searchBox={true} // Boolean to show/hide search input box
            onSearchHandler={onSearch} // Function called on key up in the search box
            exportBtn={true} // Boolean to show/hide export button
            onExportBtnClick={onExportBtnClick} // Callback for when the export button is clicked
            exportBtnLoading={exportStatus?.loading} // Boolean flag to show loading state during export functionality
            rightBtn={true} // Boolean to show/hide right-side button (for example, a back button)
            rightBtnTitle={"Add IP"} // String for setting the right button's label
            rightBtnRoute={"/add-ip"} // Route for the right button's navigation
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "name", name: "Name" },
            ]} // Array of options to populate the ordering dropdown (value and name pair)
          />
          <GeneralTables
            data={data?.data} // Array containing the data to be displayed in the table
            loading={loading} // Boolean indicating the loading state of the table
            headers={["#", "Name", "Code", "Action"]} // Array of strings representing the column headers for the table
            /*
                - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            */
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(ip, index) => (
              <tr key={index}>
                <th scope="row">{data?.meta?.from + index}</th>
                <td>{ip.name}</td>
                <td>{ip.code}</td>
                <td>
                  {/* Action Columns Component is use for action colums (Edit, Delete, detail) */}
                  <ActionColumns
                    data={ip}
                    enableEdit={true}
                    enableDelete={true}
                    editRoute={`/edit-ip/${ip.id}`}
                    onClickDelete={onClickDelete}
                  />
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default IPListComponent
